export default "__VITE_ASSET__CGpTQVoU__"